<template>
  <div :class="`products-container ${productsContainerAdditionalClass}`">
    <div v-for="product in products" :key="product.id" class="product-box">
      <div style="display: flex; flex-direction: column; justify-content: space-between; height: 100%">
        <div v-if="!fromExternalLink">
          <router-link :id="`open-${product.id}`" :key="`open-${product.id}`" :to="{name: 'product', params: { productId: product.id }}">
            <Product_inner_details :product="product" />
          </router-link>
        </div>

        <div v-if="fromExternalLink">
          <a :href="`${baseUrlForExternal}/product/${product.id}`" target="_blank">
            <Product_inner_details :product="product" />
          </a>
        </div>

        <div v-if="!hideCartControls" class="add-cart-container">
          <input
            :ref="`quant-${product.id}`"
            class="quantity-input"
            type="number"
            min="1"
            value="1"
          >
          <button class="buy-btn" @click="addToCart(product.id, $refs[`quant-${product.id}`][0].value)">
            <i class="fas fa-plus" />&nbsp;
            Add
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Product_inner_details from "./product_inner_details";
export default {
  components: {Product_inner_details},
  props: {
    products: { required: true, type: Array, default() { return []; }},
    hideCartControls: { required: false, type: Boolean, default: false },
    fromExternalLink: { required: false, default: false, type: Boolean },
    baseUrlForExternal: { required: false, type: String, default: null },
    productsContainerAdditionalClass: { required: false, type: String, default: null },
  },
  methods: {
    addToCart: function(productId, quantity) {
      this.$store.dispatch('addProduct', { productId: productId, quantity: parseInt(quantity, 10) });
    },
  },
};
</script>
